import { FacilityInfoSection } from "./FacilityInfoSection";
import { PersonalInfoSection } from "./PersonalInfoSection";
import { PracticeLocation } from "../npiLookup";
import { SectionProps } from "./useAccountInfoFields";

/** The clinician's personal and facility details; `prefilled` sections start
 * read-only. */
export const AccountInfoForm = ({
  prefilled = { personal: false, facility: false },
  practiceLocations = [],
  ...props
}: SectionProps & {
  prefilled?: { personal: boolean; facility: boolean };
  // NPPES's practice locations, to pick from when there are several.
  practiceLocations?: PracticeLocation[];
}) => (
  <div className="tw-mt-[16px] tw-flex tw-w-full tw-flex-col tw-gap-[16px]">
    <PersonalInfoSection {...props} prefilled={prefilled.personal} />
    <FacilityInfoSection
      {...props}
      prefilled={prefilled.facility}
      practiceLocations={practiceLocations}
    />
  </div>
);
